import { MUITooltip } from "@abb/arcadia-ui-react"
import { TooltipProps } from "@abb/arcadia-ui-react/build/components/tooltip/types"
import styled from "@emotion/styled"

const DEFAULT_MAX_WIDTH = 200
const FONT_SIZE = 12

type InputProps = {
  custommaxwidth?: number
}

const HtmlTooltip = styled(({ custommaxwidth, ...props }: TooltipProps & InputProps) => (
  <div style={{ maxWidth: custommaxwidth ?? DEFAULT_MAX_WIDTH, fontSize: FONT_SIZE }}>
    <MUITooltip {...props} />
  </div>
))``

export default HtmlTooltip
